// File: c:\Users\sasa\Desktop\ERC\WP APP VUE\DEVELOPMENT\erc_wp_plugin\app\src\utils\urlUtils.js
const LIVE_STORAGE_DOMAIN = 'https://pro.ecuremapcenter.com';

/**
 * Constructs the full URL for an asset.
 * - If the path is already a full URL, it's returned as is.
 * - If the path starts with '/storage/', it prepends the LIVE_STORAGE_DOMAIN.
 * - Returns null for empty or invalid paths.
 * @param {string|null} path The asset path from the API.
 * @returns {string|null} The full URL or null.
 */
export function getFullAssetUrl(path) {
  if (!path || typeof path !== 'string') {
    return null;
  }
  const trimmedPath = path.trim();
  if (trimmedPath.startsWith('http://') || trimmedPath.startsWith('https://')) {
    return trimmedPath; // Already a full URL
  }
  if (trimmedPath.startsWith('/storage/')) {
    return `${LIVE_STORAGE_DOMAIN}${trimmedPath}`; // Prepend domain for live API paths
  }
 // Handles paths like "generations/image.webp" or "models/image.jpg" (without leading slash)
 if (trimmedPath.includes('/') && !trimmedPath.startsWith('/')) {
  return `${LIVE_STORAGE_DOMAIN}/storage/${trimmedPath}`;
}
// If it's just a filename or an unhandled format, log a warning and return it as is (might be broken)
console.warn(`getFullAssetUrl: Received an unhandled path format: ${trimmedPath}. It might not load correctly.`);
return trimmedPath;
}
